
export default function UseCases() {
  const personas = [
    {
      title: 'Busy Parents',
      description: 'Find calm and clarity in the chaos of daily life with quick, grounding practices.',
      icon: 'ri-parent-line',
      gradient: 'from-[#FFE8DC] to-[#FFE4E8]'
    },
    {
      title: 'High Performers',
      description: 'Stay centered and intentional while managing ambitious goals and demanding schedules.',
      icon: 'ri-rocket-line',
      gradient: 'from-[#E8F4FF] to-[#E8F0FF]'
    },
    {
      title: 'Healing & Rebuilding',
      description: 'Rebuild your sense of self with compassionate affirmations and reflective practices.',
      icon: 'ri-heart-pulse-line',
      gradient: 'from-[#FFE4E8] to-[#F0E8FF]'
    },
    {
      title: 'Spiritual but Practical',
      description: 'Integrate mindfulness and self-awareness into everyday life without the woo-woo.',
      icon: 'ri-compass-3-line',
      gradient: 'from-[#F0E8FF] to-[#E8F4FF]'
    }
  ];

  return (
    <section className="bg-gradient-to-b from-[#FDFBF7] to-[#F7F3EF] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-5 gap-16 items-center">
          {/* Left Panel - 40% */}
          <div className="lg:col-span-2 relative">
            {/* Decorative Background Shape */}
            <div className="absolute -top-8 -left-8 w-64 h-64 bg-[#FFE4E8]/30 rounded-full blur-3xl"></div>
            
            <div className="relative z-10">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-6">
                Who It's For
              </h2>
              <p className="text-lg text-[#5A5A5A] leading-relaxed">
                Whether you're navigating change, seeking clarity, or building a stronger mindset, this system meets you where you are.
              </p>
            </div>
          </div>

          {/* Right Panel - 60% */}
          <div className="lg:col-span-3">
            <div className="grid sm:grid-cols-2 gap-6">
              {personas.map((persona, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${persona.gradient} flex items-center justify-center mb-6`}>
                    <i className={`${persona.icon} text-2xl text-[#2C2C2C]`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-[#2C2C2C] mb-3">
                    {persona.title}
                  </h3>
                  <p className="text-sm text-[#5A5A5A] leading-relaxed">
                    {persona.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
